var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _g4, _path7, _path8, _g5, _path9, _g6, _path10, _path11, _g7, _path12, _g8, _path13, _path14, _g9, _path15, _g10, _path16, _path17, _g11, _path18, _g12, _path19, _path20, _g13, _path21, _g14, _path22, _path23, _g15, _path24, _g16, _path25, _path26, _g17, _path27, _g18, _path28, _path29, _g19, _path30, _g20, _path31, _path32, _g21, _path33, _g22, _path34, _g23, _path35, _g24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterswitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 35,
    viewBox: "0 0 132 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3627 18.2581L43.811 15.8726C43.811 15.8726 40.3587 14.8247 37.549 16.7681V26.311H40.5327V18.5578C41.7217 17.6623 43.3627 18.2581 43.3627 18.2581",
    fill: "#00425F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 15,
    width: 7,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5487 16.7681C38.9006 15.8333 40.4013 15.5906 41.5946 15.5908C42.8814 15.5908 43.8109 15.8728 43.8109 15.8728L43.3624 18.2583C43.3624 18.2583 41.7214 17.6625 40.5324 18.5578V26.311H37.5487V16.7681Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-144.081 55.8878L276.106 55.8878L276.106 -500.451H-144.081L-144.081 55.8878Z",
    fill: "#00425F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 15,
    width: 7,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5487 16.7681C38.9006 15.8333 40.4011 15.5908 41.5946 15.5908C42.8814 15.5908 43.8109 15.8728 43.8109 15.8728L43.3624 18.2583C43.3624 18.2583 41.7214 17.6625 40.5324 18.5578V26.311H37.5487V16.7681Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5464 30.9862H48.813V10.9156H32.5464V30.9862Z",
    fill: "#00425F"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6392 13.1522L20.6215 12.627V15.7307H23.5727V18.2126H20.6215V21.9141C20.6215 22.5446 20.7306 23.0452 20.9537 23.4153C21.1742 23.7912 21.6165 23.9774 22.2807 23.9774C22.6054 23.9774 22.9316 23.9483 23.2756 23.8866C23.61 23.8238 23.9217 23.7431 24.2022 23.6375L24.6242 25.9623C24.2632 26.1071 23.8642 26.2327 23.4243 26.3392C22.983 26.4447 22.4412 26.4997 21.801 26.4997C20.9872 26.4997 20.3147 26.3888 19.7799 26.1688C19.2478 25.9489 18.82 25.6402 18.5011 25.2464C18.1821 24.856 17.9579 24.3769 17.832 23.8159C17.7038 23.256 17.6392 22.6377 17.6392 21.9556V13.1522Z",
    fill: "#00425F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 8,
    height: 15
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6392 13.1522L20.6215 12.627V15.7306H23.5727V18.2126H20.6215V21.9141C20.6215 22.5448 20.7306 23.0452 20.9535 23.4153C21.174 23.7913 21.6163 23.9774 22.2805 23.9774C22.6052 23.9774 22.9312 23.9483 23.2754 23.8866C23.6098 23.8238 23.9217 23.7431 24.2022 23.6377L24.624 25.9623C24.2632 26.1073 23.864 26.2329 23.4241 26.3394C22.9828 26.4448 22.441 26.4997 21.8008 26.4997C20.9868 26.4997 20.3145 26.3888 19.7799 26.1688C19.2476 25.9489 18.8196 25.6402 18.5009 25.2466C18.1819 24.856 17.9579 24.3769 17.832 23.8159C17.7036 23.256 17.6392 22.6378 17.6392 21.9556V13.1522Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-144.081 55.8878L276.106 55.8878L276.106 -500.451H-144.081L-144.081 55.8878Z",
    fill: "#00425F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 8,
    height: 15
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6392 13.1522L20.6215 12.627V15.7306H23.5727V18.2126H20.6215V21.9141C20.6215 22.5448 20.7306 23.0452 20.9535 23.4153C21.174 23.7913 21.6163 23.9774 22.2805 23.9774C22.6052 23.9774 22.9312 23.9483 23.2754 23.8866C23.6098 23.8238 23.9217 23.7431 24.2022 23.6377L24.624 25.9623C24.2632 26.1073 23.864 26.2329 23.4241 26.3394C22.9828 26.4448 22.441 26.4997 21.8008 26.4997C20.9868 26.4997 20.3145 26.3888 19.7799 26.1688C19.2476 25.9489 18.8196 25.6402 18.5009 25.2466C18.1819 24.856 17.9579 24.3769 17.832 23.8159C17.7036 23.256 17.6392 22.6378 17.6392 21.9556V13.1522Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6367 31.1749H29.6261V7.95187H12.6367L12.6367 31.1749Z",
    fill: "#00425F"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2283 24.174C48.7738 24.174 49.1597 24.1177 49.3889 24.0123C49.6164 23.9058 49.7267 23.6971 49.7267 23.3919C49.7267 23.1507 49.5829 22.9409 49.2879 22.7625C48.9932 22.5807 48.5495 22.3788 47.9479 22.1487C47.4815 21.9748 47.0572 21.7954 46.6748 21.6102C46.2972 21.4218 45.9736 21.2018 45.7063 20.9403C45.44 20.6801 45.2338 20.3681 45.0852 20.0046C44.9365 19.6477 44.866 19.2158 44.866 18.7063C44.866 17.72 45.2338 16.9379 45.9664 16.3646C46.6999 15.7935 47.7046 15.5019 48.9871 15.5019C49.6285 15.5019 50.2422 15.559 50.8296 15.6746C51.4158 15.7868 51.8846 15.9148 52.2284 16.0437L51.7094 18.3662C51.3618 18.2462 50.9843 18.1408 50.5779 18.0488C50.1715 17.9547 49.7136 17.9052 49.2077 17.9052C48.2739 17.9052 47.8063 18.1677 47.8063 18.6872C47.8063 18.8072 47.8267 18.9139 47.8675 19.007C47.9082 19.1013 47.9875 19.1911 48.105 19.2774C48.2283 19.3628 48.389 19.4591 48.5975 19.558C48.8048 19.6623 49.0686 19.7699 49.3889 19.8923C50.0396 20.1346 50.5802 20.3702 51.0071 20.6082C51.4349 20.846 51.7706 21.0964 52.0188 21.3744C52.2656 21.6461 52.4408 21.9469 52.539 22.281C52.6374 22.6144 52.6888 22.9992 52.6888 23.438C52.6888 24.4781 52.298 25.2645 51.52 25.7964C50.7384 26.326 49.6332 26.593 48.2055 26.593C47.2729 26.593 46.4961 26.5156 45.8764 26.353C45.2543 26.1948 44.8251 26.058 44.5854 25.9524L45.0852 23.531C45.59 23.7308 46.115 23.8855 46.6449 24.0024C47.1819 24.1168 47.7046 24.174 48.2283 24.174",
    fill: "#00425F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 15,
    width: 9,
    height: 12
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9664 16.3648C46.7001 15.7935 47.7046 15.5019 48.9871 15.5019C49.6287 15.5019 50.2424 15.559 50.8298 15.6746C51.4158 15.7868 51.8846 15.9146 52.2286 16.0437L51.7096 18.3662C51.3618 18.2462 50.9845 18.1408 50.5779 18.0488C50.1717 17.9545 49.7136 17.9054 49.2079 17.9054C48.2739 17.9054 47.8065 18.1676 47.8065 18.6872C47.8065 18.8072 47.8267 18.9139 47.8675 19.007C47.9084 19.1013 47.9877 19.1911 48.1052 19.2774C48.2283 19.3628 48.3892 19.4591 48.5977 19.558C48.805 19.6621 49.0686 19.7701 49.3889 19.8923C50.0398 20.1346 50.5804 20.3702 51.0071 20.6082C51.4351 20.846 51.7708 21.0962 52.019 21.3744C52.2658 21.6461 52.4408 21.9467 52.5392 22.281C52.6376 22.6144 52.6888 22.9992 52.6888 23.438C52.6888 24.4781 52.298 25.2647 51.5202 25.7964C50.7386 26.326 49.6334 26.593 48.2057 26.593C47.2731 26.593 46.4963 26.5156 45.8766 26.353C45.2543 26.1948 44.8253 26.058 44.5854 25.9524L45.0854 23.531C45.5902 23.731 46.115 23.8855 46.6449 24.0024C47.1819 24.1166 47.7046 24.174 48.2283 24.174C48.7738 24.174 49.1599 24.1179 49.3889 24.0123C49.6166 23.9058 49.7269 23.6971 49.7269 23.3919C49.7269 23.1507 49.5831 22.9409 49.2881 22.7625C48.9932 22.5807 48.5495 22.3788 47.9479 22.1487C47.4815 21.9748 47.0574 21.7954 46.6748 21.6102C46.2974 21.4218 45.9736 21.2018 45.7065 20.9403C45.4402 20.68 45.234 20.3681 45.0854 20.0046C44.9367 19.6475 44.866 19.2158 44.866 18.7063C44.866 17.7202 45.234 16.9381 45.9664 16.3648Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-144.081 55.8878L276.106 55.8878L276.106 -500.451H-144.081L-144.081 55.8878Z",
    fill: "#00425F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 15,
    width: 9,
    height: 12
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9664 16.3648C46.7001 15.7935 47.7046 15.5019 48.9871 15.5019C49.6287 15.5019 50.2424 15.559 50.8298 15.6746C51.4158 15.7868 51.8846 15.9146 52.2286 16.0437L51.7096 18.3662C51.3618 18.2462 50.9845 18.1408 50.5779 18.0488C50.1717 17.9545 49.7136 17.9054 49.2079 17.9054C48.2739 17.9054 47.8065 18.1676 47.8065 18.6872C47.8065 18.8072 47.8267 18.9139 47.8675 19.007C47.9084 19.1013 47.9877 19.1911 48.1052 19.2774C48.2283 19.3628 48.3892 19.4591 48.5977 19.558C48.805 19.6621 49.0686 19.7701 49.3889 19.8923C50.0398 20.1346 50.5804 20.3702 51.0071 20.6082C51.4351 20.846 51.7708 21.0962 52.019 21.3744C52.2658 21.6461 52.4408 21.9467 52.5392 22.281C52.6376 22.6144 52.6888 22.9992 52.6888 23.438C52.6888 24.4781 52.298 25.2647 51.5202 25.7964C50.7386 26.326 49.6334 26.593 48.2057 26.593C47.2731 26.593 46.4963 26.5156 45.8766 26.353C45.2543 26.1948 44.8253 26.058 44.5854 25.9524L45.0854 23.531C45.5902 23.731 46.115 23.8855 46.6449 24.0024C47.1819 24.1166 47.7046 24.174 48.2283 24.174C48.7738 24.174 49.1599 24.1179 49.3889 24.0123C49.6166 23.9058 49.7269 23.6971 49.7269 23.3919C49.7269 23.1507 49.5831 22.9409 49.2881 22.7625C48.9932 22.5807 48.5495 22.3788 47.9479 22.1487C47.4815 21.9748 47.0574 21.7954 46.6748 21.6102C46.2974 21.4218 45.9736 21.2018 45.7065 20.9403C45.4402 20.68 45.234 20.3681 45.0854 20.0046C44.9367 19.6475 44.866 19.2158 44.866 18.7063C44.866 17.7202 45.234 16.9381 45.9664 16.3648Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5833 31.2682H57.6912V10.8267H39.5833V31.2682Z",
    fill: "#00425F"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8809 20.2676C61.6136 21.282 61.3318 22.2919 61.031 23.2904C60.7312 24.2924 60.4123 25.3001 60.0828 26.3143H57.7609C57.5199 25.7533 57.2575 25.0869 56.9769 24.3137C56.6938 23.5373 56.4051 22.6946 56.1018 21.778C55.8019 20.8645 55.4953 19.8975 55.181 18.8741C54.8658 17.8554 54.5601 16.8253 54.2677 15.7829H57.4108C57.515 16.262 57.6337 16.7884 57.7619 17.3548C57.8891 17.9226 58.0233 18.5072 58.1636 19.1087C58.3039 19.7079 58.4537 20.3102 58.607 20.9184C58.7617 21.5266 58.9201 22.1089 59.0804 22.669C59.2544 22.0821 59.4247 21.4829 59.5913 20.8691C59.7555 20.2543 59.9174 19.6505 60.0719 19.0571C60.2243 18.4646 60.3741 17.8891 60.5106 17.3348C60.6498 16.7814 60.7733 16.262 60.8824 15.7829H63.0412C63.1515 16.262 63.2676 16.7814 63.403 17.3348C63.5349 17.8891 63.6754 18.4646 63.824 19.0571C63.9678 19.6505 64.1248 20.2543 64.2819 20.8691C64.4436 21.4829 64.6092 22.0821 64.7806 22.669C64.9423 22.1089 65.1031 21.5266 65.2648 20.9184C65.4267 20.3102 65.5788 19.7079 65.7179 19.1087C65.857 18.5072 65.9913 17.9226 66.1208 17.3548C66.249 16.7884 66.3653 16.262 66.4719 15.7829L69.5743 15.7829C69.2795 16.8253 68.9762 17.8554 68.6609 18.8741C68.3432 19.8975 68.0398 20.8645 67.7367 21.778C67.438 22.6946 67.1433 23.5373 66.8567 24.3137C66.5679 25.0869 66.3016 25.7533 66.0645 26.3143H63.7426C63.4067 25.3001 63.0808 24.2924 62.7595 23.2904C62.4394 22.2919 62.1493 21.282 61.8809 20.2676",
    fill: "#00425F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 15,
    width: 16,
    height: 12
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4719 15.7831L69.5743 15.7831C69.2795 16.8255 68.9762 17.8556 68.6607 18.8741C68.3432 19.8976 68.0398 20.8649 67.7365 21.7782C67.438 22.6948 67.1433 23.5375 66.8565 24.3139C66.5677 25.087 66.3016 25.7533 66.0643 26.3145H63.7424C63.4067 25.3003 63.0808 24.2924 62.7595 23.2904C62.4394 22.2921 62.1493 21.2822 61.8809 20.2678C61.6134 21.2822 61.3316 22.2921 61.031 23.2904C60.7312 24.2924 60.4123 25.3003 60.0826 26.3145H57.7607C57.5197 25.7533 57.2573 25.087 56.9767 24.3139C56.6938 23.5375 56.4049 22.6948 56.1018 21.7782C55.8019 20.8649 55.4951 19.8976 55.181 18.8741C54.8658 17.8556 54.5601 16.8255 54.2677 15.7831H57.4106C57.515 16.2622 57.6337 16.7884 57.7619 17.355C57.8891 17.9228 58.0231 18.5074 58.1636 19.1087C58.3037 19.7079 58.4537 20.3104 58.607 20.9186C58.7617 21.5267 58.9201 22.1091 59.0804 22.6691C59.2542 22.0823 59.4245 21.4829 59.5911 20.8692C59.7553 20.2545 59.9174 19.6507 60.0719 19.0573C60.2241 18.4646 60.3739 17.8891 60.5106 17.335C60.6498 16.7816 60.7733 16.2622 60.8822 15.7831H63.0412C63.1513 16.2622 63.2676 16.7816 63.403 17.335C63.5349 17.8891 63.6754 18.4646 63.8238 19.0573C63.9678 19.6507 64.1246 20.2545 64.2819 20.8692C64.4436 21.4829 64.6092 22.0823 64.7804 22.6691C64.9423 22.1091 65.1029 21.5267 65.2648 20.9186C65.4267 20.3104 65.5788 19.7079 65.7179 19.1087C65.857 18.5074 65.9913 17.9228 66.1206 17.355C66.249 16.7884 66.3653 16.2622 66.4719 15.7831Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-144.081 55.8878L276.106 55.8878L276.106 -500.451H-144.081L-144.081 55.8878Z",
    fill: "#00425F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 15,
    width: 16,
    height: 12
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4719 15.7831L69.5743 15.7831C69.2795 16.8255 68.9762 17.8556 68.6607 18.8741C68.3432 19.8976 68.0398 20.8649 67.7365 21.7782C67.438 22.6948 67.1433 23.5375 66.8565 24.3139C66.5677 25.087 66.3016 25.7533 66.0643 26.3145H63.7424C63.4067 25.3003 63.0808 24.2924 62.7595 23.2904C62.4394 22.2921 62.1493 21.2822 61.8809 20.2678C61.6134 21.2822 61.3316 22.2921 61.031 23.2904C60.7312 24.2924 60.4123 25.3003 60.0826 26.3145H57.7607C57.5197 25.7533 57.2573 25.087 56.9767 24.3139C56.6938 23.5375 56.4049 22.6948 56.1018 21.7782C55.8019 20.8649 55.4951 19.8976 55.181 18.8741C54.8658 17.8556 54.5601 16.8255 54.2677 15.7831H57.4106C57.515 16.2622 57.6337 16.7884 57.7619 17.355C57.8891 17.9228 58.0231 18.5074 58.1636 19.1087C58.3037 19.7079 58.4537 20.3104 58.607 20.9186C58.7617 21.5267 58.9201 22.1091 59.0804 22.6691C59.2542 22.0823 59.4245 21.4829 59.5911 20.8692C59.7553 20.2545 59.9174 19.6507 60.0719 19.0573C60.2241 18.4646 60.3739 17.8891 60.5106 17.335C60.6498 16.7816 60.7733 16.2622 60.8822 15.7831H63.0412C63.1513 16.2622 63.2676 16.7816 63.403 17.335C63.5349 17.8891 63.6754 18.4646 63.8238 19.0573C63.9678 19.6507 64.1246 20.2545 64.2819 20.8692C64.4436 21.4829 64.6092 22.0823 64.7804 22.6691C64.9423 22.1091 65.1029 21.5267 65.2648 20.9186C65.4267 20.3104 65.5788 19.7079 65.7179 19.1087C65.857 18.5074 65.9913 17.9228 66.1206 17.355C66.249 16.7884 66.3653 16.2622 66.4719 15.7831Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2655 30.9897H74.5766V11.108H49.2655V30.9897Z",
    fill: "#00425F"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6824 26.3103H74.6601V15.7811H71.6824V26.3103Z",
    fill: "#00425F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 4,
    height: 12
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6824 26.3105V15.7814H74.6603V26.3105H71.6824Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-144.081 55.8878L276.106 55.8878L276.106 -500.451H-144.081L-144.081 55.8878Z",
    fill: "#00425F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 4,
    height: 12
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6824 26.3105V15.7814H74.6603V26.3105H71.6824Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6799 30.9856H79.662V11.1061H66.6799V30.9856Z",
    fill: "#00425F"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0288 13.1553L80.0088 12.6269V15.7864H82.9579V18.2639H80.0088V21.9689C80.0088 22.596 80.1191 23.1011 80.3385 23.4702C80.5579 23.8438 81.0025 24.0312 81.668 24.0312C81.9904 24.0312 82.3212 24.0042 82.6592 23.9425C83.0008 23.8819 83.3101 23.7956 83.5919 23.6912L84.0103 26.0139C83.6493 26.1617 83.2478 26.2876 82.8104 26.3952C82.3678 26.5006 81.8322 26.5545 81.1895 26.5545C80.3745 26.5545 79.702 26.4447 79.1686 26.2224C78.634 26.0059 78.2071 25.6996 77.8884 25.3023C77.5694 24.9119 77.3466 24.4305 77.2184 23.873C77.0888 23.3109 77.0288 22.6892 77.0288 22.0102V13.1553Z",
    fill: "#00425F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 12,
    width: 8,
    height: 15
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0288 13.1553L80.0086 12.6269V15.7864H82.9577V18.2639H80.0086V21.9689C80.0086 22.596 80.1191 23.1009 80.3385 23.4702C80.5579 23.8438 81.0025 24.031 81.6678 24.031C81.9902 24.031 82.3212 24.0042 82.6592 23.9425C83.0008 23.8817 83.3102 23.7956 83.5917 23.6912L84.0101 26.0137C83.6493 26.1617 83.2476 26.2876 82.8104 26.3952C82.3678 26.5006 81.8322 26.5545 81.1895 26.5545C80.3745 26.5545 79.7018 26.4447 79.1686 26.2224C78.6338 26.0057 78.2071 25.6996 77.8884 25.3025C77.5694 24.9119 77.3466 24.4307 77.2182 23.873C77.0888 23.3109 77.0288 22.689 77.0288 22.0104V13.1553Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-144.082 55.8878L276.106 55.8878L276.106 -500.451H-144.082L-144.082 55.8878Z",
    fill: "#00425F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 12,
    width: 8,
    height: 15
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0288 13.1553L80.0086 12.6269V15.7864H82.9577V18.2639H80.0086V21.9689C80.0086 22.596 80.1191 23.1009 80.3385 23.4702C80.5579 23.8438 81.0025 24.031 81.6678 24.031C81.9902 24.031 82.3212 24.0042 82.6592 23.9425C83.0008 23.8817 83.3102 23.7956 83.5917 23.6912L84.0101 26.0137C83.6493 26.1617 83.2476 26.2876 82.8104 26.3952C82.3678 26.5006 81.8322 26.5545 81.1895 26.5545C80.3745 26.5545 79.7018 26.4447 79.1686 26.2224C78.6338 26.0057 78.2071 25.6996 77.8884 25.3025C77.5694 24.9119 77.3466 24.4307 77.2182 23.873C77.0888 23.3109 77.0288 22.689 77.0288 22.0104V13.1553Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.0264 31.2298H89.0124V7.9517H72.0264V31.2298Z",
    fill: "#00425F"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0635 21.0512C85.0635 20.2892 85.1872 19.5712 85.434 18.898C85.6809 18.2225 86.037 17.6369 86.5034 17.1353C86.9708 16.6338 87.5366 16.2387 88.2054 15.9437C88.8707 15.6531 89.6308 15.5027 90.4843 15.5027C91.044 15.5027 91.5583 15.5555 92.0257 15.6542C92.4935 15.7563 92.949 15.8989 93.3864 16.0839L92.768 18.4661C92.4863 18.3605 92.1804 18.2686 91.8449 18.1855C91.5116 18.1069 91.1364 18.0656 90.7241 18.0656C89.8443 18.0656 89.186 18.3403 88.7556 18.8878C88.318 19.4366 88.1047 20.1559 88.1047 21.0512C88.1047 21.9969 88.3073 22.7318 88.7174 23.2526C89.1201 23.7721 89.8322 24.0335 90.8451 24.0335C91.2059 24.0335 91.5907 23.9986 92.0067 23.9325C92.4191 23.8651 92.799 23.7597 93.1491 23.6116L93.5664 26.0554C93.2185 26.2023 92.7871 26.3258 92.2669 26.4345C91.7442 26.5403 91.1722 26.5951 90.5466 26.5951C89.5863 26.5951 88.757 26.4492 88.0652 26.163C87.3725 25.877 86.8005 25.4864 86.3546 24.9928C85.9051 24.498 85.5815 23.9146 85.3742 23.2413C85.1667 22.567 85.0635 21.8356 85.0635 21.0512",
    fill: "#00425F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 15,
    width: 9,
    height: 12
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2054 15.9437C88.8707 15.6531 89.6307 15.5027 90.4843 15.5027C91.044 15.5027 91.5583 15.5553 92.0257 15.654C92.4933 15.7563 92.949 15.8987 93.3864 16.0839L92.768 18.4659C92.4861 18.3605 92.1804 18.2686 91.8447 18.1855C91.5114 18.1067 91.1364 18.0654 90.7239 18.0654C89.8443 18.0654 89.186 18.3403 88.7556 18.8878C88.318 19.4365 88.1047 20.1557 88.1047 21.0512C88.1047 21.9969 88.3075 22.7318 88.7174 23.2526C89.1201 23.7721 89.832 24.0335 90.8449 24.0335C91.2059 24.0335 91.5907 23.9986 92.0066 23.9325C92.4191 23.8651 92.799 23.7597 93.1489 23.6115L93.5662 26.0554C93.2186 26.2023 92.7871 26.3256 92.2667 26.4345C91.7442 26.5401 91.1724 26.5951 90.5466 26.5951C89.5861 26.5951 88.757 26.4491 88.0651 26.1628C87.3725 25.8768 86.8005 25.4864 86.3544 24.9929C85.9053 24.498 85.5815 23.9146 85.3742 23.2413C85.1667 22.567 85.0635 21.8354 85.0635 21.0512C85.0635 20.2892 85.1872 19.5712 85.434 18.898C85.6809 18.2225 86.037 17.6367 86.5032 17.1351C86.9708 16.6336 87.5366 16.2387 88.2054 15.9437Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-144.081 55.8878L276.106 55.8878L276.106 -500.451H-144.081L-144.081 55.8878Z",
    fill: "#00425F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 15,
    width: 9,
    height: 12
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2054 15.9437C88.8707 15.6531 89.6307 15.5027 90.4843 15.5027C91.044 15.5027 91.5583 15.5553 92.0257 15.654C92.4933 15.7563 92.949 15.8987 93.3864 16.0839L92.768 18.4659C92.4861 18.3605 92.1804 18.2686 91.8447 18.1855C91.5114 18.1067 91.1364 18.0654 90.7239 18.0654C89.8443 18.0654 89.186 18.3403 88.7556 18.8878C88.318 19.4365 88.1047 20.1557 88.1047 21.0512C88.1047 21.9969 88.3075 22.7318 88.7174 23.2526C89.1201 23.7721 89.832 24.0335 90.8449 24.0335C91.2059 24.0335 91.5907 23.9986 92.0066 23.9325C92.4191 23.8651 92.799 23.7597 93.1489 23.6115L93.5662 26.0554C93.2186 26.2023 92.7871 26.3256 92.2667 26.4345C91.7442 26.5401 91.1724 26.5951 90.5466 26.5951C89.5861 26.5951 88.757 26.4491 88.0651 26.1628C87.3725 25.8768 86.8005 25.4864 86.3544 24.9929C85.9053 24.498 85.5815 23.9146 85.3742 23.2413C85.1667 22.567 85.0635 21.8354 85.0635 21.0512C85.0635 20.2892 85.1872 19.5712 85.434 18.898C85.6809 18.2225 86.037 17.6367 86.5032 17.1351C86.9708 16.6336 87.5366 16.2387 88.2054 15.9437Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0612 31.2704H98.5682V10.8276H80.0612V31.2704Z",
    fill: "#00425F"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4929 26.3105V13.1513L98.4741 12.6275V15.8252C98.673 15.7589 98.9285 15.695 99.2451 15.6346C99.5566 15.575 99.8623 15.5435 100.155 15.5435C101.007 15.5435 101.715 15.6613 102.284 15.8937C102.85 16.1271 103.306 16.4581 103.644 16.8855C103.987 17.3108 104.224 17.8201 104.367 18.4048C104.505 18.9937 104.574 19.6492 104.574 20.3695V26.3105H101.594V20.7273C101.594 19.7668 101.471 19.0869 101.225 18.6841C100.978 18.2879 100.52 18.0872 99.855 18.0872C99.5842 18.0872 99.337 18.1109 99.1022 18.1557C98.8696 18.2029 98.66 18.2544 98.4741 18.3072V26.3105H95.4929Z",
    fill: "#00425F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 12,
    width: 10,
    height: 15
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.4929 13.1513L98.4739 12.6275V15.8254C98.673 15.7589 98.9285 15.695 99.2451 15.6346C99.5566 15.575 99.8623 15.5437 100.155 15.5437C101.007 15.5437 101.716 15.6615 102.284 15.8937C102.85 16.1273 103.306 16.4582 103.644 16.8857C103.987 17.3108 104.225 17.8201 104.367 18.405C104.505 18.9938 104.574 19.6492 104.574 20.3697V26.3105H101.594V20.7273C101.594 19.767 101.471 19.0869 101.225 18.6841C100.978 18.2881 100.52 18.0872 99.855 18.0872C99.5842 18.0872 99.337 18.1109 99.1022 18.1559C98.8696 18.2029 98.66 18.2544 98.4739 18.3072V26.3105H95.4929V13.1513Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-144.081 55.8878L276.106 55.8878L276.106 -500.451H-144.081L-144.081 55.8878Z",
    fill: "#00425F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 12,
    width: 10,
    height: 15
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.4929 13.1513L98.4739 12.6275V15.8254C98.673 15.7589 98.9285 15.695 99.2451 15.6346C99.5566 15.575 99.8623 15.5437 100.155 15.5437C101.007 15.5437 101.716 15.6615 102.284 15.8937C102.85 16.1273 103.306 16.4582 103.644 16.8857C103.987 17.3108 104.225 17.8201 104.367 18.405C104.505 18.9938 104.574 19.6492 104.574 20.3697V26.3105H101.594V20.7273C101.594 19.767 101.471 19.0869 101.225 18.6841C100.978 18.2881 100.52 18.0872 99.855 18.0872C99.5842 18.0872 99.337 18.1109 99.1022 18.1559C98.8696 18.2029 98.66 18.2544 98.4739 18.3072V26.3105H95.4929V13.1513Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4906 30.9858H109.576V7.95218H90.4906V30.9858Z",
    fill: "#00425F"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61267 26.314L5.61267 16.7723C5.61267 16.7723 7.11106 15.5751 10.3884 15.5751C13.3708 15.5751 15.0085 17.0663 15.0085 20.3482V26.314H12.0296V20.3482C12.0296 18.2579 10.9842 18.1131 10.0911 18.1131C9.19803 18.1131 8.59992 18.5574 8.59992 18.5574V26.314H5.61267Z",
    fill: "#00425F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 15,
    width: 11,
    height: 12
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61267 16.7723C5.61267 16.7723 7.11106 15.5751 10.3884 15.5751C13.3708 15.5751 15.0083 17.0661 15.0083 20.3484V26.314H12.0296V20.3484C12.0296 18.2577 10.9842 18.1131 10.0911 18.1131C9.19803 18.1131 8.59992 18.5576 8.59992 18.5576V26.314H5.61267L5.61267 16.7723Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-144.081 55.8878L276.106 55.8878L276.106 -500.451H-144.081L-144.081 55.8878Z",
    fill: "#00425F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 15,
    width: 11,
    height: 12
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61267 16.7723C5.61267 16.7723 7.11106 15.5751 10.3884 15.5751C13.3708 15.5751 15.0083 17.0661 15.0083 20.3484V26.314H12.0296V20.3484C12.0296 18.2577 10.9842 18.1131 10.0911 18.1131C9.19803 18.1131 8.59992 18.5576 8.59992 18.5576V26.314H5.61267L5.61267 16.7723Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.610718 30.9893H20.0106V10.9001H0.610718L0.610718 30.9893Z",
    fill: "#00425F"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.314L0 13.1525L2.98239 12.6273L2.98239 26.314H0Z",
    fill: "#00425F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 12,
    width: 3,
    height: 15
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.1527L2.98239 12.6273L2.98239 26.314H0L0 13.1527Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-144.081 55.8878L276.106 55.8878L276.106 -500.451H-144.081L-144.081 55.8878Z",
    fill: "#00425F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 12,
    width: 3,
    height: 15
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.1527L2.98239 12.6273L2.98239 26.314H0L0 13.1527Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.0022 30.9893H7.98479L7.98479 7.95241H-5.0022L-5.0022 30.9893Z",
    fill: "#00425F"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5085 21.8052H35.2167C35.5163 20.012 35.2167 15.5442 30.7431 15.5442C27.7617 15.5442 25.6759 17.6289 25.6759 20.9121C25.6759 25.0869 28.3587 26.576 31.3424 26.576C33.4282 26.576 34.9182 25.9846 34.9182 25.9846L34.6197 23.5958C34.6197 23.5958 33.1285 24.0414 31.6371 24.0414C28.6583 24.0414 28.5085 21.8052 28.5085 21.8052ZM28.5084 19.7158C28.5084 19.7158 28.6582 17.6289 30.5967 17.6289C32.5339 17.6289 32.68 19.7158 32.68 19.7158H28.5084Z",
    fill: "#00425F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 15,
    width: 11,
    height: 12
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6761 20.9119C25.6761 17.6287 27.762 15.5441 30.7432 15.5441C35.2167 15.5441 35.5164 20.012 35.2167 21.805H28.5087C28.5087 21.805 28.6585 24.0412 31.6372 24.0412C33.1286 24.0412 34.6198 23.5956 34.6198 23.5956L34.9182 25.9844C34.9182 25.9844 33.4282 26.576 31.3424 26.576C28.3589 26.576 25.6761 25.0869 25.6761 20.9119ZM30.5968 17.6287C28.6585 17.6287 28.5087 19.7158 28.5087 19.7158H32.6802C32.6802 19.7158 32.5339 17.6287 30.5968 17.6287Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-144.081 55.8878L276.106 55.8878L276.106 -500.451H-144.081L-144.081 55.8878Z",
    fill: "#00425F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 15,
    width: 11,
    height: 12
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6761 20.9119C25.6761 17.6287 27.762 15.5441 30.7432 15.5441C35.2167 15.5441 35.5164 20.012 35.2167 21.805H28.5087C28.5087 21.805 28.6585 24.0412 31.6372 24.0412C33.1286 24.0412 34.6198 23.5956 34.6198 23.5956L34.9182 25.9844C34.9182 25.9844 33.4282 26.576 31.3424 26.576C28.3589 26.576 25.6761 25.0869 25.6761 20.9119ZM30.5968 17.6287C28.6585 17.6287 28.5087 19.7158 28.5087 19.7158H32.6802C32.6802 19.7158 32.5339 17.6287 30.5968 17.6287Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.674 31.2511H40.3025V10.8689H20.674V31.2511Z",
    fill: "#00425F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 10,
    width: 21,
    height: 25
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.525 12.63C108.525 11.9938 117.099 10.6209 122.849 10.6209C125.343 10.6209 127.306 10.8791 127.808 11.5674C130.397 14.763 112.169 34.8114 110.65 34.2032C109.432 33.8991 120.368 21.1383 118.545 15.9715C117.635 13.2393 108.525 13.5432 108.525 12.63Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.523 38.892H133.061V5.9459H103.523V38.892Z",
    fill: "#EE312A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_123_3371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 0,
    width: 8,
    height: 9
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.012 4.73149C124.012 2.54922 125.78 0.783182 127.959 0.783182C130.141 0.783182 131.906 2.54922 131.906 4.73149C131.906 6.91487 130.141 8.68091 127.959 8.68091C125.78 8.68091 124.012 6.91487 124.012 4.73149Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_123_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.009 13.3561L136.909 13.3561V-3.89217H119.009V13.3561Z",
    fill: "#EE312A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterswitch);
export default __webpack_public_path__ + "static/media/interswitch.2aa9a5351c774704a1c48b441845bf2b.svg";
export { ForwardRef as ReactComponent };